<div mat-dialog-content>
  <p class="mat-dialog-title">{{isDocument}} Check-In</p>
  <mat-radio-group
    class="save-versions-radio-group"
    aria-label="Select an option"
    [(ngModel)]="sectionType"
  >
    <mat-radio-button [value]="1">minor changes (1.1)</mat-radio-button>
    <mat-radio-button [value]="2">major changes (2.0)</mat-radio-button>
  </mat-radio-group>
  <mat-form-field class="save-versions-form-field">
    <textarea
      matInput
      [(ngModel)]="data.comment"
      class="save-versions-text-area"
      placeholder="{{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.COMMENT' | translate }}"
    >
    </textarea>
  </mat-form-field>
</div>
<div mat-dialog-actions class="save-versions-dialog-actions">
  <button mat-button class="save-button" (click)="save()">Check In</button>
  <button mat-button class="close-button" (click)="close()">Cancel</button>
</div>
